import { render, staticRenderFns } from "./DoughnutChartTile.vue?vue&type=template&id=3afe6d0c&scoped=true&"
import script from "./DoughnutChartTile.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartTile.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartTile.scss?vue&type=style&index=0&id=3afe6d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe6d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCard,VCardText,VSpacer})
